export default "__VITE_ASSET__D2yU6CXd__"